import { POSLeaderboardMapper } from "@/data/persistences/mappers/POSLeaderboardMapper";
import { POSLeaderboardRepositoryInterface } from "@/data/persistences/repositories/contracts/POSLeaderboardRepositoryInterface";
import { POSLeaderboardEndpoint } from "@/app/infrastructures/endpoints/POSLeaderboardEndpoint";
import ApiService from "@/app/infrastructures/services/ApiService";
import { PosLeaderboard } from "@/domain/entities/PosLeaderboard";
import { SummaryApiRequest } from "@/data/payload/api/PosLeaderboard";
import { PosLeaderboardList } from "@/domain/entities/PosLeaderboard";
import { POSLeaderboardListRequest } from "@/data/payload/api/POSLeaderboardApiRequest";

export class POSLeaderboardApiRepository
  implements POSLeaderboardRepositoryInterface {
  private service: ApiService;
  private mapper: POSLeaderboardMapper;
  private endpoints: POSLeaderboardEndpoint;

  constructor(
    service: ApiService,
    mapper: POSLeaderboardMapper,
    endpoints: POSLeaderboardEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getSummary(params: SummaryApiRequest): Promise<PosLeaderboard> {
    const response = await this.service.invoke(
      "get",
      this.endpoints.getSummary(params),
      {}
    );
    return this.mapper.convertSummaryFromApi(response);
  }

  async getLeaderboardList(params: POSLeaderboardListRequest): Promise<PosLeaderboardList> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.posLeaderboard(params),
    )

    return this.mapper.convertPOSLeaderboardListFromApi(resp);
  }

  async getConfig(params: SummaryApiRequest) {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getConfig(params)
    )

    return this.mapper.convertConfigFromApi(resp);
  }
}

